import api from './api';

export const ownerInquiryReviewAPI = {
  get: (inquiryId) => api.get(`/owner/inquiries/${inquiryId}/review`),
  patch: (inquiryId, payload) => api.patch(`/owner/inquiries/${inquiryId}/review`, payload),
};
